import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateCourse as updateCourseApi } from "@/services/dashboard/apiCourses";
import toast from "react-hot-toast";

function useUpdateCourse() {
    const queryClient = useQueryClient();

    const {
        mutate: updateCourse,
        isLoading: isUpdating,
        error,
    } = useMutation({
        mutationFn: updateCourseApi,

        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["coursesDashboard"],
            });

            toast.success("تم تعديل الكورس بنجاح");
        },

        onError: (error) => {
            toast.error(error.response.data.message);
        },
    });

    return { updateCourse, isUpdating, error };
}

export default useUpdateCourse;
